import { useQuery } from "@tanstack/react-query";
import { CountryCode } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { isAxiosError } from "axios";
import { AltTransIncidentMeasurePlanStatus } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { log } from "logging/datadogBrowserLogs";
import { Nullish } from "shared/utils/objectUtils";

// Very partial type
type AlternativeTransportIncidentPlanEvent = {
  country_code: CountryCode;
  incident_id: string;
  status: AltTransIncidentMeasurePlanStatus;
};

type RelatedInfrastructureIncidentPlanResponse = {
  created_at: string;
  updated_at: string;
  report_type: "INCIDENT";
  revision: number;
  sensitivity: "SENSITIVE" | "NOT_SENSITIVE";
  uuid: string;
  version: number;
  priority: { value: number };
  event: AlternativeTransportIncidentPlanEvent;
};

export const useRelatedInfrastructureIncidentPlan = (
  incidentId: Nullish<string>,
) =>
  useQuery({
    queryKey: ["relatedInfrastructureIncidentPlan", incidentId],
    refetchInterval: 60 * 60 * 1000,
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      queryFnGET<RelatedInfrastructureIncidentPlanResponse>({
        signal,
        url: `${getBackendUrl()}/alternative-transport-planning/incident/${incidentId}/related-plan/latest`,
      }).catch((reason) => {
        if (isAxiosError(reason)) {
          if (reason.status !== 404) {
            log(
              "error",
              "useRelatedInfrastructureIncidentPlan",
              reason.message,
              reason,
            );
          }
          return null;
        }

        throw reason;
      }),
    gcTime: 0,
    enabled: !!incidentId,
  });
